import React from 'react'
import { Inbox } from 'react-bootstrap-icons'

/**
 * Loading, empty and error, so no modal ever shows a blank white box.
 */

/** Mirrors the real layout rather than dropping a spinner in the middle. */
export const ModalSkeleton = ({ media = false, rows = 3 }) => (
  <div className='d-flex flex-column gap-4'>
    {media && (
      <div className='app-modal__skeleton' style={{ height: '11.5rem' }} />
    )}
    {Array.from({ length: rows }).map((_, index) => (
      <div key={index} className='app-modal__grid'>
        <div className='d-flex flex-column gap-2'>
          <div className='app-modal__skeleton' style={{ width: '40%' }} />
          <div className='app-modal__skeleton' style={{ height: '2.9rem' }} />
        </div>
        <div className='d-flex flex-column gap-2'>
          <div className='app-modal__skeleton' style={{ width: '52%' }} />
          <div className='app-modal__skeleton' style={{ height: '2.9rem' }} />
        </div>
      </div>
    ))}
  </div>
)

/** Says why it is empty and offers the way out, rather than "No data". */
export const ModalEmpty = ({ icon, title, text, action }) => (
  <div className='app-modal__empty'>
    <span className='app-modal__empty-icon'>{icon || <Inbox />}</span>
    <span className='app-modal__empty-title'>{title}</span>
    {text && <span className='app-modal__empty-text'>{text}</span>}
    {action && <div className='mt-3'>{action}</div>}
  </div>
)

/** In-body failure. Validation errors belong in the footer via ModalActions. */
export const ModalError = ({ title = 'Something went wrong', text, action }) => (
  <div className='app-modal__empty'>
    <span
      className='app-modal__empty-icon'
      style={{ background: 'var(--kt-danger-light)', color: 'var(--kt-danger)' }}
    >
      !
    </span>
    <span className='app-modal__empty-title'>{title}</span>
    {text && <span className='app-modal__empty-text'>{text}</span>}
    {action && <div className='mt-3'>{action}</div>}
  </div>
)
